import { SpaceControlWorkSpaceWorkSpaceTypeEnum } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

// TODO: Remove this and use enum types and values from GraphQL
export const workSpaceTypesDic = {
  desk: 'desk',
  meetingroom: 'meeting_room',
  booth: 'booth',
  lunch: 'lunch',
  parking: 'parking',
  other: 'other',
}

export const workSpaceTypeBackLabel = (type: SpaceControlWorkSpaceWorkSpaceTypeEnum) => {
  switch (type) {
    case 'desk':
      return i18n.t('space_control.space_type.desk')
    case 'meeting_room':
      return i18n.t('space_control.space_type.meeting_room')
    case 'booth':
      return i18n.t('space_control.space_type.booth')
    case 'lunch':
      return i18n.t('space_control.space_type.lunch')
    case 'parking':
      return i18n.t('space_control.space_type.parking')
    default:
    case 'other':
      return i18n.t('space_control.space_type.other')
  }
}
